import { leafPath, r2 } from "./shapes";

/*
 * Marigold torans: swags of genda flowers with mango leaves between them and strings
 * (ladis) of flowers hanging from each joint, ending in a rose or a brass bell.
 */

const UNIT = 120;
const SAG = 30;

// Points along one swag (a shallow catenary between two hooks).
const SWAG = (() => {
  const pts = [];
  for (let i = 0; i <= 17; i += 1) {
    const t = i / 17;
    pts.push([t * UNIT, 6 + SAG * (1 - Math.pow(2 * t - 1, 2))]);
  }
  return pts;
})();
const LEAVES = SWAG.filter((_, i) => i % 2).map(([x, y], i) => ({ x, y: y + 4, rot: 90 + (i % 2 ? 14 : -14) }));
const COLORS = ["ut-marigold", "ut-marigold", "ut-marigold-yellow"];

/** One swag of the toran, plus the string hanging from its left hook. viewBox 0 0 120 120. */
const Swag = ({ index, hang }) => {
  const length = hang === "long" ? 8 : 5;
  return (
    <svg className="ut-toran__swag" viewBox={`0 0 ${UNIT} 120`} aria-hidden="true" overflow="visible">
      {LEAVES.map((l, i) => (
        <path key={i} d={leafPath(15, 0.36)} fill={i % 2 ? "#3e7d2c" : "#5fa83a"} transform={`translate(${r2(l.x)} ${r2(l.y)}) rotate(${l.rot})`} />
      ))}
      {SWAG.map(([x, y], i) => (
        <use key={i} href={`#${COLORS[(i + index) % 3]}`} x={r2(x - 7.5)} y={r2(y - 7.5)} width="15" height="15" />
      ))}
      {/* The hanging string, swaying from its hook (styles/_hero.scss, .ut-toran__ladi) */}
      <g transform="translate(0 8)">
        <g className="ut-toran__ladi" style={{ "--i": index }}>
          <line x1="0" y1="0" x2="0" y2={length * 9} stroke="#c9962b" strokeWidth="0.8" />
          {Array.from({ length }, (_, k) => (
            <use key={k} href={`#${k % 2 ? "ut-marigold-yellow" : "ut-marigold"}`} x="-6" y={k * 9} width="12" height="12" />
          ))}
          {index % 2 ? (
            <use href="#ut-rose" x="-7" y={6 + length * 9 - 4} width="14" height="14" />
          ) : (
            <g transform={`translate(0 ${2 + length * 9})`}>
              <circle cy="2" r="1.8" fill="url(#ut-gold)" />
              <path d="M0,3 C-5,3 -5.6,10 -6.4,15 L6.4,15 C5.6,10 5,3 0,3 Z" fill="url(#ut-gold)" />
              <rect x="-7.2" y="14.4" width="14.4" height="2.2" rx="1.1" fill="#b5841f" />
              <circle cy="18.6" r="1.7" fill="#a8761c" />
            </g>
          )}
        </g>
      </g>
    </svg>
  );
};

/**
 * A toran across the full width of its container. Swags repeat as many times as fit;
 * the container clips the overflow.
 */
export const Toran = ({ className = "", count = 24 }) => (
  <div className={`ut-toran ${className}`} aria-hidden="true">
    {Array.from({ length: count }, (_, i) => (
      <Swag key={i} index={i} hang={i % 2 ? "short" : "long"} />
    ))}
  </div>
);

export default Toran;
